import { render } from "./faq.vue?vue&type=template&id=30be5345"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__